import { useEffect } from 'react'
import { FieldHookConfig, useField } from 'formik'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface StaticFieldProps<Value> extends Pick<FieldHookConfig<Value>, 'name' | 'validate'> {
  hidden?: boolean // hidden wil not hide the field value while still passing it to formvalues
  value?: Value
}

/**
 * StaticField will render as static value that the user can't change, but will be present in the formvalues
 * A value can be passed to set a new static value
 */
export function StaticField<Value>({ hidden, name, value, validate }: StaticFieldProps<Value>) {
  const [input, , helpers] = useField<Value | undefined>({ name, validate })
  useRegisterFormField(name)

  useEffect(() => {
    if (input.value !== value) {
      helpers.setValue(value)
    }
  }, [value])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return hidden ? null : <>{input.value}</> || ''
}
